import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import Month from "./Month";
import Day from "./Day";
import Year from "./Year";

export default function Dates({ id, label, tooltip, day, month, year, closingMonth, isValid, onChange }) {
  return (
    <div className="dates">
      {closingMonth ? <h5>Dates</h5> : null}
      <p className="form-group">{label}</p>
      <Form.Row>
        <OverlayTrigger
          rootClose
          placement="right-start"
          trigger={tooltip ? ["hover"] : ""}
          overlay={
            <Tooltip id="overlay-example" className="helpTooltip month">
              <strong>{label}</strong>
              <br />
              This is the date on which the entity began doing business. If you are starting a new business, enter the
              starting date of the business. If the business you acquired is already operating, enter the date you
              acquired the business. If you are changing the form of ownership of your business, enter the date the new
              ownership entity began.
            </Tooltip>
          }
        >
          <Form.Group as={Col} controlId={id + "Month"}>
            <Month defaultValue={month} isValid={isValid} onChange={onChange} />
          </Form.Group>
        </OverlayTrigger>
        <Day
          controlId={id + "Day"}
          defaultValue={day}
          month={month}
          year={year}
          isValid={isValid}
          onChange={onChange}
        />
        <Year controlId={id + "Year"} defaultValue={year} tooltip={tooltip} isValid={isValid} onChange={onChange} />
      </Form.Row>
      {closingMonth ? (
        <OverlayTrigger
          rootClose
          placement="right-start"
          overlay={
            <Tooltip id="overlay-example" className="helpTooltip">
              <strong>Closing Month of Accounting Year</strong>
              <br />
              The closing month of the accounting year is the last month of your accounting year or tax year. An
              accounting or tax year is usually 12 consecutive months, based on either a calendar year or a fiscal year
              (including a period of 52 or 53 weeks).
              <br />A calendar year is 12 consecutive months ending on December 31. A fiscal year is either 12
              consecutive months ending on the last day of any month (other than December) or a special 52-53 week year
              ending on a fixed day of the week (for example, the last Friday in March rather than March 31). For more
              information on accounting periods, see Pub. 538.
            </Tooltip>
          }
        >
          <Form.Group controlId="closingMonth">
            <Form.Label>Closing month of accounting year</Form.Label>
            <Month defaultValue={closingMonth} onChange={onChange} />
          </Form.Group>
        </OverlayTrigger>
      ) : null}
    </div>
  );
}
